import React from 'react';
import TextAreaLimiter from '@components/common/TextAreaLimiter';
import { Typography } from '@mui/material';
import { Box } from '@mui/system';

const CompleteEventFields = ({ form }) => {
  return (
    <Box>
      <TextAreaLimiter
        name="comments"
        id="comments"
        control={form.control}
        label="Feel free to share any final details about your event—like how it went working with the site or partner, any challenges or wins, what you learned, and any tips or ideas for next time."
        InputLabelProps={{
          sx: { fontWeight: 'normal' },
        }}
        staticLabel
        fullWidth
        rows={3}
      />
      <Typography variant="body1" sx={{ marginTop: '24px' }}>
        Once you mark this event as complete it will no longer be editable.
      </Typography>
    </Box>
  );
};

export default CompleteEventFields;
